import { createApp } from 'vue'
import { router } from './router'
import store from './store'
import App from './App.vue'
// element
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './styles/my-theme.less';
import "./libs/css/public.less";
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// echarts
import chinaJson from '@/assets/map/china.json'
// import BeijingJson from '@/assets/map/beijingshi.json'
import * as echarts from 'echarts'
// custome
import './permission' // permission control
// fix Passive Event Listeners warning
// import 'default-passive-events'
import Notifications from '@kyvg/vue3-notification'
const app = createApp(App)
// eacharts
echarts.registerMap('china', { geoJSON: chinaJson })
// echarts.registerMap('beijing', { geoJSON: BeijingJson })
app.config.globalProperties.$echarts = echarts
// vuex
app.use(store)
app.use(ElementPlus, {
  locale: zhCn
})
// vue route
app.use(ViewUIPlus)
app.use(router)
app.use(Notifications)
// register all element icon
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component)
// }
// 挂载根节点
app.mount('#app')
